export const sortOptions = [
  { value: 'last_activity' },
  { value: 'unread' },
  { value: 'unread_anyone' },
  { value: 'favorite' }
];

export const downloadOptions = [
  { value: 0, translationKey: 'today' },
  { value: 7, translationKey: 'last7Days' },
  { value: 30, translationKey: 'last30Days' },
  { value: 'RANGE', translationKey: 'customize' }
];

export const selectOptions = [{ value: 'read' }, { value: 'unread' }, { value: 'favorite' }, { value: 'noFavorite' }];

export const queryOptionFilters = [{ value: 'feedback_not_responded' }];

export const multiSelectOptions = [
  {
    value: 1,
    tabFilter: 1,
    selected: false,
    translationKey: 'email',
    sitesEnabled: ['24MX', 'CAPA', 'DVPE', 'ICBR', 'IWBR', 'LLVE', 'PLEC', 'UBPE', 'WIBR', 'CMBR', 'VAMX', 'ZPAR']
  },
  {
    value: 3,
    tabFilter: 1,
    selected: false,
    translationKey: 'calendar',
    sitesEnabled: ['24MX', 'CAPA', 'DVPE', 'ICBR', 'IWBR', 'LLVE', 'PLEC', 'UBPE', 'WIBR', 'CMBR', 'VAMX', 'ZPAR']
  },
  {
    value: 2,
    tabFilter: 1,
    selected: false,
    translationKey: 'phoneCall',
    sitesEnabled: []
  },
  {
    value: 10,
    tabFilter: 10,
    selected: false,
    translationKey: 'whatsapp',
    sitesEnabled: ['24MX', 'CAPA', 'DVPE', 'ICBR', 'IWBR', 'LLVE', 'PLEC', 'UBPE', 'WIBR', 'CMBR', 'VAMX', 'ZPAR']
  },
  { value: 11, tabFilter: 99, selected: false, translationKey: 'megaphone', sitesEnabled: [] },
  {
    value: 12,
    tabFilter: 1,
    selected: false,
    translationKey: 'money',
    sitesEnabled: ['24MX', 'CAPA', 'DVPE', 'ICBR', 'IWBR', 'LLVE', 'PLEC', 'UBPE', 'WIBR', 'CMBR', 'VAMX', 'ZPAR']
  },
  {
    value: 6,
    tabFilter: 6,
    selected: false,
    translationKey: 'view',
    sitesEnabled: ['24MX', 'CAPA', 'DVPE', 'ICBR', 'IWBR', 'LLVE', 'PLEC', 'UBPE', 'WIBR', 'CMBR', 'VAMX', 'ZPAR']
  },

  {
    value: 14,
    tabFilter: 1,
    selected: false,
    translationKey: 'quote',
    sitesEnabled: ['DVPE', 'UBPE']
  }
];

export default {
  sortOptions,
  downloadOptions,
  selectOptions,
  multiSelectOptions,
  queryOptionFilters
};
